import React from "react";
import TableDropdown from "../../../shared/Table/TableDropdown";
import Avatar from "../../../shared/Avatar";
import { ThemeType } from "../../../types";
import { IUser } from "../../../types/userType";
import { formatDate2 } from "../../../utils/wordUtils";
import Role from "../../../shared/Role";
import ImageSet from "../../../shared/ImageSet";
import NoData from "../../../shared/NoData";
import { useHistory } from "react-router-dom";

interface CardTableProps {
	theme?: ThemeType;
	data?: IUser[];
}

const headings: string[] = [
	"name",
	"products",
	"email",
	"phone",
	"role",
	"joined",
];

const defaultProps: CardTableProps = {
	theme: "light",
};

const UserTable = ({ theme, data }: CardTableProps): JSX.Element => {
	const history = useHistory();
	return (
		<div className="block w-full overflow-x-scroll">
			{/* Projects table */}
			<table className="items-center w-full bg-transparent border-collapse">
				<thead>
					<tr>
						{headings.map((heading) => {
							return (
								<th
									key={heading}
									className={
										"px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
										(theme === "light"
											? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
											: "bg-blueGray-600 text-lightBlue-300 border-lightBlue-700")
									}
								>
									{heading}
								</th>
							);
						})}
						<th
							className={
								"px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
								(theme === "light"
									? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
									: "bg-blueGray-600 text-lightBlue-300 border-lightBlue-700")
							}
						>
							Action
						</th>
					</tr>
				</thead>
				<tbody>
					{data?.map((d, i) => {
						return (
							<tr
								key={d._id}
								className={`${
									theme === "light" ? "hover:bg-sky-50" : "hover:bg-slate-500"
								} z-10 cursor-pointer ${
									i % 2 === 0 ? "bg-white" : "bg-slate-50"
								}`}
								onClick={() => {
									history.push(`/dashboard/user/${d._id}/info`);
								}}
							>
								<td className="table-data text-left flex items-center">
									<Avatar
										imgUrl={d.profile?.avatar || "/avatar.png"}
										sizeClass="h-12 w-12"
										hasChecked={d.verified}
									></Avatar>{" "}
									<div
										className={
											" ml-3 font-bold " +
											+(theme === "light" ? "text-blueGray-600" : "text-white")
										}
									>
										<p>{d.profile?.displayName || "-"}</p>
										<p className="font-normal">
											{d.name || d.profile?.fullName || "-"}
										</p>
									</div>
								</td>
								<td className="table-data">
									{d.products?.length! > 0 ? (
										<div>
											{" "}
											<ImageSet images={d.products} />
										</div>
									) : (
										<NoData></NoData>
									)}
								</td>
								<td className="table-data">{d.email}</td>
								<td className="table-data">
									{d.profile?.phone ? d.profile.phone : <NoData></NoData>}
								</td>
								<td className="table-data">
									{d.admin && <Role type="admin" />}
									{d.products?.length! > 0 && <Role type="vendor" />}
								</td>
								<td className="table-data">
									{d.createdAt ? formatDate2(d.createdAt) : "No data"}
								</td>
								<td className="table-data text-right">
									<TableDropdown id={d._id} type="user" />
								</td>
							</tr>
						);
					})}
				</tbody>
			</table>
			{!data?.length && (
				<div className="text-center w-full italic text-sm py-4 text-slate-400">
					No data
				</div>
			)}
		</div>
	);
};

UserTable.defaultProps = defaultProps;

export default UserTable;
